import * as bootstrap from "bootstrap"

// Bootstrap's data-api treats a [data-bs-toggle="modal"] click while another
// modal is open as a swap: it hides the open modal first. For modals nested
// inside another modal (e.g. add-target inside the metric edit modal) we want
// stacking instead — open the child ourselves and stop the event before
// Bootstrap's handler sees it. Bootstrap's delegated data-api listener is
// capture-phase on document, so ours must sit on window (visited first).
window.addEventListener("click", (event) => {
  const trigger = event.target.closest('[data-bs-toggle="modal"]')
  if (!trigger) return
  if (!trigger.closest(".modal.show")) return

  const selector = trigger.dataset.bsTarget || trigger.getAttribute("href")
  const child = selector && document.querySelector(selector)
  if (!child || child.classList.contains("show")) return

  event.preventDefault()
  event.stopPropagation()
  // stopPropagation also starves Bootstrap's document-level dropdown
  // handler, which would otherwise close the menu this click came from
  // (e.g. a more-actions dropdown opening a confirmation modal) — close
  // open dropdowns ourselves.
  for (const menu of document.querySelectorAll(".dropdown-menu.show")) {
    const toggle = menu.parentElement?.querySelector('[data-bs-toggle="dropdown"]')
    if (toggle) bootstrap.Dropdown.getOrCreateInstance(toggle).hide()
  }
  bootstrap.Modal.getOrCreateInstance(child).show(trigger)
}, true)

// Bootstrap removes body.modal-open whenever any modal hides, even if
// another is still open — restore it so the page behind stays locked.
// Also hand focus back to the modal underneath: with data-bs-focus="false"
// (no FocusTrap) nobody else will, and Bootstrap's Escape handler only
// hears keydowns dispatched from inside the modal element — without this a
// second Escape could not close the parent modal.
document.addEventListener("hidden.bs.modal", () => {
  const open = document.querySelectorAll(".modal.show")
  if (!open.length) { return }

  document.body.classList.add("modal-open")

  const top = open[open.length - 1]
  if (!top.contains(document.activeElement)) {
    top.focus({ preventScroll: true })
  }
})

// With stacked modals, Escape bubbles through both and would close
// everything (losing the parent's form state). Close only the innermost.
document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return

  const open = document.querySelectorAll(".modal.show")
  if (open.length < 2) return

  event.stopPropagation()
  bootstrap.Modal.getInstance(open[open.length - 1])?.hide()
}, true)
